import React from "react";
import Axios from "axios";
import axios from "services/axios";
import { Button, Card, message, Spin, Tooltip, Tag } from "antd";
import MUIDataTable from "mui-datatables";
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";
import { Link } from "react-router-dom";
import _ from "lodash";

import ModalBranchAreaDetail from "./ModalBranchAreaDetail";
import { errorMessage } from "../../../Utils";

let cancelToken;

class BranchAreaList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      areaDetail: {},
      areas: [],
      isLoading: true,
      confirmLoading: false,
      disableButton: true,
      page: 1,
      limit: 15,
      count: 0,
      search: "",
      sort: { name: "date", direction: "desc" },
    };
    this.visibleModalDetail = this.visibleModalDetail.bind(this);
  }

  componentDidMount() {
    this.setState({ isLoading: true });
    this.fetchBranchArea(this.state.page, this.state.limit);
  }

  orderBy(sort) {
    let key = "name";
    let value = "DESC";

    //Get Value
    if (sort.direction === "asc") value = "ASC";
    else if (sort.direction === "desc") value = "DESC";

    return `${key}=${value}`;
  }

  async fetchBranchArea(page, limit) {
    const order = this.orderBy(this.state.sort);
    const query = `${order}&&page=${page}&&limit=${limit}&&search=${
      this.state.search || ""
    }`;
    if (cancelToken) {
      cancelToken.cancel("Operation canceled due to new request");
    }
    cancelToken = Axios.CancelToken.source();

    await axios
      .get(`admin-panel/branch-area?${query}`, {
        cancelToken: cancelToken.token,
      })
      .then((result) => {
        this.setState({
          areas: result.data.areas,
          page: result.data.page,
          limit: result.data.limit,
          count: result.data.count,
          isLoading: false,
        });
      })
      .catch((err) => {
        if (!Axios.isCancel(err)) {
          errorMessage(err.response || err);
          this.setState({ isLoading: false });
        }
      });
  }

  changePage(page, limit) {
    this.setState({ isLoading: true });
    this.fetchBranchArea(page, limit);
  }

  visibleModalDetail(area) {
    this.setState({
      visibleModalDetail: !this.state.visibleModalDetail,
      areaDetail: area,
    });
  }

  getMuiTheme = () =>
    createMuiTheme({
      typography: {
        useNextVariants: true,
      },
      overrides: {
        MUIDataTableBodyCell: {
          root: {
            "white-space": "nowrap",
            "&:nth-child(1)": {
              width: "8em",
              "min-width": "8em",
              "max-width": "10em",
              "word-break": "break-all",
            },
          },
        },
      },
    });

  render() {
    //Columns
    const columns = [
      {
        name: "Action",
        options: {
          sort: false,
        },
      },
      {
        name: "Area Name",
        options: {
          sort: false,
        },
      },
      {
        name: "Branch Internal",
        options: {
          sort: false,
        },
      },
      {
        name: "Branch Code",
        options: {
          sort: false,
        },
      },
      {
        name: "BOH Name",
        options: {
          sort: false,
        },
      },
      {
        name: "GM Name",
        options: {
          sort: false,
        },
      },
      {
        name: "Pricing Area",
        options: {
          sort: false,
        },
      },
    ];

    //Data areas
    const areas = this.state.areas.map((item, idx) => {
      return [
        <div>
          <Tooltip placement="bottom" title="Detail Area">
            <Button
              icon="bars"
              style={{ marginRight: 10 }}
              onClick={() => this.visibleModalDetail(item)}
            />
          </Tooltip>
          <Tooltip placement="bottom" title="Update Area">
            <Button
              type="primary"
              icon="edit"
              onClick={() =>
                this.props.history.push({
                  pathname: `/home/branch-area/${item.id}/update`,
                })
              }
            />
          </Tooltip>
        </div>,
        item.name,
        item.internalBranch,
        item.codeBranch,
        item.BOHProfile
          ? item.BOHProfile.User
            ? item.BOHProfile.User.name
            : ""
          : "",
        item.GeneralManager ? item.GeneralManager.name : "",
        item.AreaPricing ? item.AreaPricing.name : "",
      ];
    });

    //Options
    const options = {
      filter: false,
      responsive: "simple",
      fixedHeader: true,
      tableBodyHeight: "460px",
      print: false,
      selectableRows: "none",
      // resizableColumns: true,
      download: false,
      viewColumns: false,
      serverSide: true,
      rowsPerPage: this.state.limit,
      count: this.state.count,
      page: this.state.page - 1,
      searchText: this.state.search,
      onTableChange: (action, tableState) => {
        switch (action) {
          case "changePage":
            this.changePage(tableState.page + 1, tableState.rowsPerPage);
            break;
          case "changeRowsPerPage":
            this.changePage(1, tableState.rowsPerPage);
            break;
          case "search":
            this.setState({ search: tableState.searchText }, () =>
              this.changePage(1, tableState.rowsPerPage)
            );
            break;
          case "sort":
            this.setState({ sort: tableState.sortOrder }, () =>
              this.changePage(1, tableState.rowsPerPage)
            );
            break;
          default:
            break;
        }
      },
    };

    return (
      <Card
        title="Branch Area List"
        style={{
          marginTop: 35,
          background: "#fff",
          minHeight: 360,
        }}>
        <Spin size="large" spinning={this.state.isLoading} tip="Loading...">
          <Link
            to={{
              pathname: `/home/branch-area/create`,
            }}>
            <Button style={{ marginRight: 8 }}>Create Branch Area</Button>
          </Link>
          <MuiThemeProvider theme={this.getMuiTheme()}>
            <MUIDataTable
              title="Branch Area List"
              data={areas}
              columns={columns}
              options={options}
            />
          </MuiThemeProvider>

          <ModalBranchAreaDetail
            data={this.state.areaDetail}
            visible={this.state.visibleModalDetail}
            visibleModal={this.visibleModalDetail}
          />
        </Spin>
      </Card>
    );
  }
}

export default BranchAreaList;



// WEBPACK FOOTER //
// src/components/Dashboard/Area/BranchArea/BranchAreaList.js